import { useEffect, useRef, useState } from "react";
import postData from "./../../utils/postData";

// import shieldImg from "./../../../../assets/images/shield_success.png";
import shieldImg from "./../../../assets/images/shield_success.png";
import "./style.scss";

const OptInModal = ({ prefix, nonce, info, ajax_url }) => {
  const [showModal, setShowModal] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const modalBtnRef = useRef();

  const handleBtnClick = (e) => {
    e.preventDefault();
    const isOptIn = modalBtnRef.current?.dataset?.status === "agree";
    if (isOptIn) {
      handleAgree();
    } else {
      setShowModal(!showModal);
    }
  };

  useEffect(() => {
    modalBtnRef.current = document.getElementById(`${prefix}OptInBtn`);
    modalBtnRef.current?.addEventListener("click", handleBtnClick);
  }, []);

  const isOptIn = () => {
    return modalBtnRef.current?.dataset?.status === "agree";
  };

  const handleAgree = async (e) => {
    e?.preventDefault();
    setIsLoading(true);

    modalBtnRef.current.setAttribute("disabled", true);

    await postData("https://api.bplugins.com/wp-json/data/v1/accept-data", { ...JSON.parse(info), status: "activate", marketing_allowed: !isOptIn() });
    await postData(`${ajax_url}?action=${prefix}-opt-in-update`, {
      nonce,
      actionType: isOptIn() ? "opt_out" : "agree",
    });

    modalBtnRef.current.innerText = isOptIn() ? "Opt In" : "Opt Out";
    modalBtnRef.current.dataset.status = isOptIn() ? "not_allowed" : "agree";

    modalBtnRef.current.removeAttribute("disabled");

    setShowModal(false);
    setIsLoading(false);
  };

  return (
    <div>
      {showModal && (
        <div id="opt_in_modal" className="opt_in_modal modal_sdk">
          <div className="opt_in_content">
            <div className="content">
              <div>
                <img src={shieldImg} alt="" />
              </div>
              <div>
                <h3>Stay on the safe side {prefix}</h3>
                <p>Receive our plugin’s alerts in case of critical security & feature updates and allow non-sensitive diagnostic tracking.</p>
              </div>
            </div>
            <div className="active-btn">
              <form method="POST">
                <button className="button button-primary" disabled={isLoading} onClick={handleAgree}>
                  Agree & continue
                </button>
              </form>
            </div>
            {showDetails && (
              <div className="granted-info">
                <h3>You&apos;re granting these permissions:</h3>
                <ul>
                  <li>Your profile information (name and email)</li>
                  <li>Your site information (URL, WP version, PHP info)</li>
                  <li>Plugin notices (updates, announcements, marketing, no spam)</li>
                  <li>Plugin events (activation, deactivation and uninstall)</li>
                </ul>
              </div>
            )}
            <div className="learn-skip">
              <a href="#" className="hide-btn" onClick={() => setShowModal(false)}>
                hide
              </a>
              <a href="#" className="learn-more-btn" onClick={() => setShowDetails(!showDetails)}>
                Learn More
              </a>
              |
              <a href="#" className="skip-btn" onClick={() => setShowModal(false)}>
                Skip
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OptInModal;
